<template>
  <div>
    <main-layout>
      <MainMenu />
      <v-container>
        <v-layout wrap class="pt-4">
          <v-flex xs12 sm6>
            <h1>{{ $t('customer_list') }}</h1>
          </v-flex>
          <v-flex xs12 sm6 class="text-sm-right text-xs-right">
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              &nbsp;
              {{ $t('advanced search') }}&nbsp;
              <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
              <em v-else class="fas fa-angle-up" />
            </v-btn>
            <v-btn dark outline color="primary" :loading="exportLoading" @click="handleExportXlsx">
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
          </v-flex>
          <v-flex>
            <div
              v-if="showAdvancedSearch"
              class="mb-4 py-2"
              style="border: 1px solid #eee; border-radius: 10px; position: relative"
            >
              <v-layout wrap class="form-control">
                <v-flex xs3 px-2>
                  <div class="caption">ชื่อ-สกุล</div>
                  <input v-model="filter.full_name" type="text" placeholder="ชื่อ-สกุล" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">ประเภทลูกค้า</div>
                  <multiselect
                    v-model="filter.customer_type"
                    :options="customerTypeOptions"
                    label="label"
                    select-label
                    selected-label
                    track-by="value"
                  ></multiselect>
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">อีเมล</div>
                  <input v-model="filter.email" type="text" placeholder="อีเมล" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">เบอร์มือถือ</div>
                  <input v-model="filter.phone_number" type="text" placeholder="เบอร์มือถือ" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">สาขา</div>
                  <multiselect
                    v-model="filter.branch_id"
                    :options="['1']"
                    select-label
                    selected-label
                  ></multiselect>
                </v-flex>

                <v-flex xs3 px-2>
                  <div class="caption">มัดจำถัง</div>
                  <multiselect
                    v-model="filter.pledge_water_tank"
                    :options="pledgeWaterTankOptions"
                    label="label"
                    select-label
                    selected-label
                    track-by="value"
                  ></multiselect>
                </v-flex>
                <v-flex xs12 class="text-xs-right">
                  <v-btn outline color="grey" @click="handleClearSearch">{{
                    $t('Clear Search')
                  }}</v-btn>
                  <v-btn depressed color="primary" @click="handleSearch">
                    <em class="fas fa-search mr-1" />
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="dataList"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template #items="props">
            <tr>
              <td>
                <v-btn
                  icon
                  outline
                  color="primary"
                  @click.stop="goToLivechat(props.item, props.item.app)"
                >
                  <em class="fas fa-comments" />
                </v-btn>
              </td>
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.created_at | DateFormat('DD/MM/YYYY HH:mm') }}</td>
              <td>{{ props.item.u_first_name || '-' }}</td>
              <td>{{ props.item.full_name || '-' }}</td>
              <td>{{ props.item.customer_type === 'old' ? 'ลูกค้าเก่า' : 'ลูกค้าใหม่' }}</td>
              <td>{{ props.item.email || '-' }}</td>
              <td>{{ props.item.phone_number || '-' }}</td>
              <td>{{ props.item.nameaddress || '-' }}</td>
              <td>{{ props.item.address_lat || '-' }}</td>
              <td>{{ props.item.address_long || '-' }}</td>
              <td>{{ findBranchName(props.item.branch_id) || '-' }}</td>
              <td>{{ props.item.pledge_water_tank ? 'มี' : 'ไม่มี' }}</td>
              <td>{{ props.item.total_pledge_water_tank || '-' }}</td>
              <td class="text-no-wrap">
                <v-btn color="primary" @click="viewUserOrderList(props.item)">{{
                  $t('Order Summary')
                }}</v-btn>
                <v-btn fab outline small color="primary" @click="handleEditCustomer(props.item.id)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pagelength"
            @input="handleChangePage"
          ></v-pagination>
        </div>
      </v-container>
      <UserOrderListDialog v-model="isUserOrderListDialogVisible" :member="selectedMember" />
    </main-layout>
  </div>
</template>

<script>
import MainMenu from './MainMenu.vue'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import Multiselect from 'vue-multiselect'
import tremendousApi from '@/api/tremendous'
import { handleResponse, handleApiError } from '@/api/util'
import UserOrderListDialog from './UserOrderListDialog.vue'
import dayjs from 'dayjs'

export default {
  components: {
    MainMenu,
    Multiselect,
    UserOrderListDialog
  },
  data() {
    return {
      showAdvancedSearch: false,
      exportLoading: false,
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      dataList: [],
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'ลำดับที่', value: 'id', sortable: false },
        { text: 'วันที่ลงทะเบียน', value: 'created_at', sortable: false },
        { text: 'social name', value: 'first_name', sortable: false },
        { text: 'ชื่อ-สกุล ที่ลงทะเบียน', value: 'full_name', sortable: false },
        { text: 'ประเภทลูกค้า', value: 'customer_type', sortable: false },
        { text: 'อีเมล', value: 'email', sortable: false },
        { text: 'เบอร์มือถือ', value: 'phone_number', sortable: false },
        { text: 'ที่อยู่', value: 'branch_id', sortable: false },
        { text: 'ละติจูด', value: 'address_lat', sortable: false },
        { text: 'ลองจิจูด', value: 'address_long', sortable: false },
        { text: 'สาขา', value: 'branch_id', sortable: false },
        { text: 'มัดจำถัง', value: 'pledge_water_tank', sortable: false },
        { text: 'จำนวนถัง', value: 'total_pledge_water_tank', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      filter: {
        full_name: '',
        customer_type: '',
        email: '',
        phone_number: '',
        branch_id: '',
        store_type: '',
        pledge_water_tank: ''
      },
      customerTypeOptions: [
        { label: 'ลูกค้าเก่า', value: 'old' },
        { label: 'ลูกค้าใหม่', value: 'new' }
      ],
      pledgeWaterTankOptions: [
        { label: 'มี', value: true },
        { label: 'ไม่มี', value: false }
      ],
      isExport: false,
      selectedMember: null,
      isUserOrderListDialogVisible: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.handleCustomerList()
    this.handleGetMasterDataBranch()
  },
  methods: {
    goToLivechat: function (user, app) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.userid || user.user_id,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app
        }
      })
      window.open(routeData.href, '_blank')
    },
    findBranchName(id) {
      if (id) {
        const data = this.$store.state.tremendousMasterData.branch.find((x) => {
          return x.id == id
        })
        if (data && data.branch_name) {
          return data.branch_name
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    async handleCustomerList() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getCustomerList()
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          vm.dataList = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    async getCustomerList() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        const data = {
          limit: limit,
          offset: vm.offset
        }

        Object.entries(vm.filter).forEach(([key, value]) => {
          if (value && Object.keys(value).length > 0) {
            Object.assign(data, { [key]: value.value })
          }
          if (value && value.length) {
            Object.assign(data, { [key]: value.toLowerCase() })
          }
        })

        const response = await tremendousApi.getCustomerList({
          pageId: vm.selectedBot.pageid,
          config: {
            params: data
          }
        })
        await handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getCustomerList()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            register_timestamp: el.created_at ? dayjs(el.created_at).format('DD/MM/YYYY') : '-',
            social_name: `${el.u_first_name ? el.u_first_name : ''} ${
              el.u_last_name ? el.u_last_name : ''
            }`,
            full_name: el.full_name,
            customer_type: el.customer_type === 'old' ? 'ลูกค้าเก่า' : 'ลูกค้าใหม่',
            email: el.email,
            phone_number: el.phone_number,
            nameaddress: el.nameaddress ? el.nameaddress : '-',
            address_lat: el.address_lat ? el.address_lat : '-',
            address_long: el.address_long ? el.address_long : '-',
            branch_name: el.branch_name,
            store_type: el.store_type,
            pledge_water_tank: el.pledge_water_tank ? 'มี' : 'ไม่มี',
            total_pledge_water_tank: el.total_pledge_water_tank
          }
        })

        const heading = [
          [
            'วันที่ลงทะเบียน',
            'social name',
            'ชื่อ-สกุล',
            'ประเภทลูกค้า',
            'อีเมล',
            'เบอร์มือถือ',
            'ที่อยู่',
            'ละติจูด',
            'ลองติจูด',
            'สาขา',
            'ประเภทร้านค้า',
            'มัดจำถัง',
            'จำนวนถัง'
          ]
        ]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `customer-list.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    handleEditCustomer(id) {
      this.$router.push(`customer/${id}`)
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleCustomerList()
      }
    },
    handleSearch() {
      this.resetPagination()
    },
    handleClearSearch() {
      this.filter = {
        full_name: '',
        customer_type: '',
        email: '',
        phone_number: '',
        branch_id: '',
        store_type: '',
        pledge_water_tank: ''
      }
      this.resetPagination()
      this.handleCloseSearch()
    },
    resetPagination() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleCustomerList()
    },
    async handleGetMasterDataBranch() {
      try {
        const response = await tremendousApi.getBranchList()
        await handleResponse(response)

        if (response && response.status === 200) {
          this.$store.state.tremendousMasterData.branch = response.data.data
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    viewUserOrderList(item) {
      this.selectedMember = item
      this.isUserOrderListDialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Tremendous/CustomerList.vue